import { useEffect, useState } from 'react';

export const useIsElementVisible = (
	ref: React.RefObject<HTMLElement>,
	options?: IntersectionObserverInit,
) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const node = ref.current;
		if (!node) {
			return;
		}

		const observer = new window.IntersectionObserver(
			([entry]) => setIsVisible(entry.isIntersecting),
			options,
		);
		observer.observe(node);

		return () => observer.disconnect();
	}, [ref, options]);

	return isVisible;
};
